
import CartSidebar from "../Cart/CartSidebar";
import CourseCard1 from "./CourseCard1";
import { useState } from "react";
import { courseCard1Object } from '../CourseCard/ExportCourseCard1Object';
const CoursesFilter= ()=>{


  const sampleItems = [
    { id: 1, title: "Product A", price: 199, qty: 1, image: "https://via.placeholder.com/80" },
    { id: 2, title: "Product B", price: 299, qty: 2, image: "https://via.placeholder.com/80" },
  ];
return(<>
<div style={{height:"70px"}}></div>

    {
    <CourseCard1 courseThemeCard1Object={courseCard1Object}  />
      }



</>)
}
export default CoursesFilter;